import React from 'react';
import { Link } from 'react-router-dom';

const MILESTONES = [
  { amount: '₹40,000', label: 'Per Student Referred', color: '#fbbf24', bg: 'rgba(251,191,36,0.15)' },
];

export default function LandingPage() {
  return (
    <div style={S.page}>

      {/* ── Hero ── */}
      <div style={S.hero}>
        <div style={S.badge}>🇬🇧 UK Referral Program — September 2026</div>
        <h1 style={S.headline} className="landing-headline">
          Refer. Earn. <span style={S.accent}>Repeat.</span>
        </h1>
        <p style={S.subline}>
          Earn <strong style={{ color: '#fbbf24' }}>₹40,000</strong> for every student you refer to UNI GLOBAL.
        </p>

        {/* ── CTA Buttons ── */}
        <div style={S.ctaRow} className="landing-cta-row">
          <Link to="/register" style={S.ctaPrimary}>Get Started — Register Free</Link>
          <Link to="/login"    style={S.ctaSecondary}>Already a Member? Login</Link>
        </div>
      </div>

      {/* ── Reward Cards ── */}
      <div style={S.cardsRow} className="landing-cards">

        {/* Referrer */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <span style={S.cardIcon}>👤</span>
            <div>
              <div style={S.cardTitle}>Your Earnings</div>
              <div style={S.cardSub}>as Referrer</div>
            </div>
          </div>
          {MILESTONES.map((m, i) => (
            <div key={i} style={{ ...S.milestone, borderLeft: `3px solid ${m.color}`, background: m.bg }}>
              <span style={{ ...S.milestoneAmt, color: m.color }}>{m.amount}</span>
              <span style={S.milestoneLabel}>{m.label}</span>
            </div>
          ))}
        </div>

      </div>

      {/* ── Loan Assurance Banner ── */}
      <div style={S.loanBanner} className="landing-loan-banner">
        <span style={{ fontSize: '2rem' }}>🏦</span>
        <div>
          <div style={S.loanTitle}>100% Education Loan Assurance</div>
          <div style={S.loanSub}>We help every student secure full education financing — no financial barriers to studying abroad.</div>
        </div>
      </div>

      {/* ── How It Works ── */}
      <div style={S.howSection}>
        <div style={S.howTitle}>How It Works</div>
        <div style={S.steps} className="landing-steps">
          {[
            { n: '1', icon: '📝', label: 'Register Free',       desc: 'Sign up and create your free referrer account' },
            { n: '2', icon: '🎓', label: 'Add a Student',       desc: 'Submit the details of anyone planning to study in the UK for Sep 2026' },
            { n: '3', icon: '🛂', label: 'We Handle the Rest',  desc: 'UNI GLOBAL guides your referral through visa, loan assurance & university enrollment' },
            { n: '4', icon: '💰', label: 'Earn ₹40,000',        desc: 'Get ₹40,000 for every student you refer' },
          ].map((s, i) => (
            <div key={i} style={S.step}>
              <div style={S.stepNum}>{s.icon}</div>
              <div style={S.stepLabel}>{s.label}</div>
              <div style={S.stepDesc}>{s.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Bottom CTA ── */}
      <div style={S.bottomCta}>
        <div style={S.bottomCtaText}>Ready to start earning?</div>
        <Link to="/register" style={S.ctaPrimary}>Create Free Account →</Link>
      </div>

      {/* ── Contact ── */}
      <div id="contact" style={S.contactSection}>
        <div style={S.contactSectionTitle}>Contact Us</div>
        <div style={S.contactSectionRow}>
          <div style={S.contactSectionItem}>
            <span style={S.contactSectionIcon}>📞</span>
            <div>
              <div style={S.contactSectionItemLabel}>Main Phone</div>
              <a href="tel:+919177454500" style={S.contactSectionMainNum}>+91 9177454500</a>
            </div>
          </div>
          <div style={S.contactSectionItem}>
            <span style={S.contactSectionIcon}>✉️</span>
            <div>
              <div style={S.contactSectionItemLabel}>Email</div>
              <a href="mailto:info@uniglobaleducon.com" style={S.contactSectionEmail}>info@uniglobaleducon.com</a>
            </div>
          </div>
          <div style={S.contactSectionItem}>
            <span style={S.contactSectionIcon}>🌐</span>
            <div>
              <div style={S.contactSectionItemLabel}>Website</div>
              <a href="https://uniglobaleducon.com/" target="_blank" rel="noopener noreferrer" style={{ ...S.contactSectionEmail, color: '#34d399' }}>uniglobaleducon.com</a>
            </div>
          </div>
        </div>
        <div style={S.contactSectionLabel}>For more information contact</div>
        <div style={S.contactSectionNums}>
          <a href="tel:7429992222" style={S.contactSectionNum}>7429992222</a>
          <span style={S.contactSectionSep}>|</span>
          <a href="tel:7429993333" style={S.contactSectionNum}>7429993333</a>
          <span style={S.contactSectionSep}>|</span>
          <a href="tel:7429995555" style={S.contactSectionNum}>7429995555</a>
        </div>
      </div>

      {/* ── Disclaimer ── */}
      <div style={S.note}>
        <span>📌</span>
        <span>Rewards are subject to verification. Payments are processed after each milestone is completed.</span>
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(145deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: '#fff',
    padding: '2.5rem 1.5rem 3rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  /* Contact Section */
  contactSection: {
    width: '100%', maxWidth: 900, marginBottom: '2rem',
    background: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.2)',
    borderRadius: 14, padding: '2rem 1.75rem', textAlign: 'center',
  },
  contactSectionTitle: {
    fontSize: '1.3rem', fontWeight: 800, color: '#e2e8f0',
    marginBottom: '1.25rem', letterSpacing: '-.01em',
  },
  contactSectionRow: {
    display: 'flex', justifyContent: 'center', gap: '2.5rem',
    flexWrap: 'wrap', marginBottom: '1.25rem',
  },
  contactSectionItem: {
    display: 'flex', alignItems: 'center', gap: '.75rem',
    background: 'rgba(255,255,255,0.04)', borderRadius: 10,
    padding: '.75rem 1.25rem',
  },
  contactSectionIcon: { fontSize: '1.5rem' },
  contactSectionItemLabel: { fontSize: '.72rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: '.2rem' },
  contactSectionMainNum: { color: '#fff', fontWeight: 800, fontSize: '1.1rem', textDecoration: 'none' },
  contactSectionEmail: { color: '#a5b4fc', fontWeight: 700, fontSize: '.95rem', textDecoration: 'none' },
  contactSectionLabel: { fontSize: '.78rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: '.6rem' },
  contactSectionNums: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '.75rem', flexWrap: 'wrap' },
  contactSectionNum: { color: '#fff', fontWeight: 800, fontSize: '1.05rem', textDecoration: 'none' },
  contactSectionSep: { color: '#6366f1', fontWeight: 700 },

  /* Hero */
  hero: { textAlign: 'center', maxWidth: 700, marginBottom: '2.5rem' },
  badge: {
    display: 'inline-flex', alignItems: 'center', gap: '.4rem',
    background: 'linear-gradient(90deg, rgba(251,191,36,0.2), rgba(244,114,182,0.2))',
    border: '1px solid rgba(251,191,36,0.4)', borderRadius: 20,
    padding: '.35rem 1.1rem', fontSize: '.82rem', fontWeight: 700,
    color: '#fde68a', letterSpacing: '.04em', marginBottom: '1.25rem',
    textTransform: 'uppercase',
  },
  headline: { fontSize: '3rem', fontWeight: 900, lineHeight: 1.15, marginBottom: '.9rem' },
  accent: {
    background: 'linear-gradient(90deg, #fbbf24, #f472b6)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
  },
  subline: { color: '#c7d2fe', fontSize: '1.05rem', lineHeight: 1.7, marginBottom: '2rem' },

  /* CTA */
  ctaRow: { display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' },
  ctaPrimary: {
    background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
    color: '#fff', borderRadius: 12, padding: '.85rem 2rem',
    fontWeight: 700, fontSize: '1rem', textDecoration: 'none',
    boxShadow: '0 4px 20px rgba(124,58,237,0.4)',
    transition: 'opacity .15s', display: 'inline-block',
  },
  ctaSecondary: {
    background: 'rgba(255,255,255,0.08)', border: '1.5px solid rgba(255,255,255,0.25)',
    color: '#e2e8f0', borderRadius: 12, padding: '.85rem 2rem',
    fontWeight: 600, fontSize: '1rem', textDecoration: 'none',
    display: 'inline-block',
  },

  /* Reward Cards */
  cardsRow: {
    display: 'grid', gridTemplateColumns: '1fr',
    gap: '1.25rem', width: '100%', maxWidth: 480, marginBottom: '2rem',
  },
  card: {
    background: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.2)',
    borderRadius: 14, padding: '1.25rem',
  },
  cardHeader: { display: 'flex', alignItems: 'center', gap: '.75rem', marginBottom: '1rem' },
  cardIcon: { fontSize: '1.6rem', flexShrink: 0 },
  cardTitle: { fontSize: '.95rem', fontWeight: 800, color: '#e2e8f0' },
  cardSub: { fontSize: '.75rem', color: '#94a3b8', marginTop: '.1rem' },
  milestone: {
    display: 'flex', flexDirection: 'column', padding: '.35rem .6rem',
    borderRadius: 7, marginBottom: '.4rem',
  },
  milestoneAmt: { fontWeight: 800, fontSize: '.95rem' },
  milestoneLabel: { color: '#cbd5e1', fontSize: '.72rem', marginTop: '.05rem' },
  cardTotal: {
    textAlign: 'center', fontSize: '.8rem', color: '#94a3b8',
    marginTop: '.75rem', paddingTop: '.75rem', borderTop: '1px solid rgba(255,255,255,.08)',
  },
  bigBonus: { textAlign: 'center', padding: '.75rem 0' },

  /* Loan Banner */
  loanBanner: {
    display: 'flex', alignItems: 'center', gap: '1.25rem',
    background: 'linear-gradient(135deg, #7c3aed, #2563eb, #0891b2)',
    borderRadius: 14, padding: '1.25rem 1.75rem',
    width: '100%', maxWidth: 900, marginBottom: '2.5rem',
    boxShadow: '0 4px 24px rgba(124,58,237,0.35)',
  },
  loanTitle: { fontSize: '1.05rem', fontWeight: 900, color: '#fff', marginBottom: '.2rem' },
  loanSub: { fontSize: '.82rem', color: '#e0f2fe', lineHeight: 1.5 },

  /* How It Works */
  howSection: { width: '100%', maxWidth: 900, marginBottom: '2.5rem', textAlign: 'center' },
  howTitle: {
    fontSize: '1.4rem', fontWeight: 800, color: '#e2e8f0',
    marginBottom: '1.5rem', letterSpacing: '-.01em',
  },
  steps: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem' },
  step: {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 12, padding: '1.25rem 1rem',
  },
  stepNum: { fontSize: '2rem', marginBottom: '.5rem' },
  stepLabel: { fontSize: '.9rem', fontWeight: 700, color: '#e2e8f0', marginBottom: '.35rem' },
  stepDesc: { fontSize: '.78rem', color: '#94a3b8', lineHeight: 1.5 },

  /* Bottom CTA */
  bottomCta: {
    textAlign: 'center', marginBottom: '2rem',
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem',
  },
  bottomCtaText: { fontSize: '1.3rem', fontWeight: 700, color: '#e2e8f0' },

  /* Disclaimer */
  note: {
    display: 'flex', gap: '.6rem', alignItems: 'flex-start',
    background: 'rgba(148,163,184,0.08)', border: '1px solid rgba(148,163,184,0.15)',
    borderRadius: 8, padding: '.7rem 1rem', fontSize: '.78rem',
    color: '#94a3b8', lineHeight: 1.5, maxWidth: 900, width: '100%',
  },
};
